import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { Reveal } from "./Reveal";

const PACKAGES = [
  {
    name: "GROWTH SPRINT",
    tagline: "One focused project, delivered fast.",
    best: "Launches, rebrands, landing pages",
    items: ["Strategy sprint & direction", "Focused deliverable set", "Design, copy & build", "Launch support"],
    featured: false,
  },
  {
    name: "STUDIO RETAINER",
    tagline: "Your always-on creative & growth team.",
    best: "Brands ready to grow every month",
    items: ["Monthly content engine", "Social media management", "Design & video production", "Optimization & reporting"],
    featured: true,
  },
  {
    name: "FULL BRAND BUILD",
    tagline: "From zero to complete brand.",
    best: "New ventures & total rebrands",
    items: ["Strategy & identity", "Website design & build", "Content & AI systems", "Launch campaign"],
    featured: false,
  },
];

export const Packages = () => (
  <section data-testid="packages-section" className="relative py-28 lg:py-40 overflow-hidden">
    <div
      aria-hidden="true"
      className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-[#6D00FF]/8 blur-[180px] rounded-full pointer-events-none"
    />
    <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
      <div className="max-w-2xl mb-16 lg:mb-20">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.28em] text-[#8B2CFF] mb-6">
            Engagement Models
          </p>
          <h2 className="font-display text-3xl sm:text-5xl font-extrabold uppercase tracking-tight leading-[1.05]">
            Three ways to{" "}
            <span className="text-gradient-purple whitespace-nowrap">move with us.</span>
          </h2>
          <p className="mt-6 text-base text-[#A6A6B0] leading-relaxed">
            Every engagement is scoped to your goals — custom quotes, no hidden tiers.
          </p>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-3 gap-5 lg:gap-6">
        {PACKAGES.map((p, i) => (
          <Reveal key={p.name} delay={i * 0.12} className="h-full">
            <article
              data-testid={`package-card-${i}`}
              className={`relative h-full glass-card rounded-lg p-8 flex flex-col transition-[transform,border-color,box-shadow] duration-500 hover:-translate-y-1.5 ${
                p.featured
                  ? "border-[#6D00FF]/50 shadow-[0_0_50px_-14px_rgba(109,0,255,0.55)]"
                  : "hover:border-[#6D00FF]/40 hover:shadow-[0_0_44px_-12px_rgba(109,0,255,0.5)]"
              }`}
            >
              {p.featured && (
                <span className="absolute -top-3 left-8 text-[10px] font-bold uppercase tracking-[0.2em] bg-[#6D00FF] text-white rounded px-3 py-1.5">
                  Most Chosen
                </span>
              )}
              <h3 className="font-display text-xl sm:text-2xl font-extrabold uppercase tracking-tight">
                {p.name}
              </h3>
              <p className="mt-3 text-sm text-white/80">{p.tagline}</p>
              <p className="mt-2 text-xs uppercase tracking-[0.16em] text-[#A6A6B0]/70">
                Best for: {p.best}
              </p>
              <ul className="mt-8 space-y-3 flex-1">
                {p.items.map((item) => (
                  <li key={item} className="flex items-start gap-3 text-sm text-[#A6A6B0]">
                    <Check className="w-4 h-4 mt-0.5 shrink-0 text-[#C43CFF]" strokeWidth={2} />
                    {item}
                  </li>
                ))}
              </ul>
              <Link
                to="/contact"
                data-testid={`package-cta-${i}`}
                className={`mt-8 flex items-center justify-center gap-2 text-xs font-bold uppercase tracking-[0.16em] px-6 py-3.5 rounded-md transition-[background-color,border-color,box-shadow,color] duration-300 ${
                  p.featured
                    ? "bg-[#6D00FF] hover:bg-[#8B2CFF] text-white hover:shadow-[0_0_32px_-8px_rgba(139,44,255,0.8)]"
                    : "border border-white/15 text-white/90 hover:border-[#8B2CFF]/60 hover:text-[#E8B6FF]"
                }`}
              >
                Enquire About This <ArrowRight className="w-4 h-4" />
              </Link>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
